/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames
 */
export interface FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames {
    /**
     * 
     * @type {string}
     * @memberof FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames
     */
    AppId: string;
}

/**
 * Check if a given object implements the FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames interface.
 */
export function instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames(value: object): value is FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames {
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    return true;
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSON(json: any): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames {
    return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames {
    if (json == null) {
        return json;
    }
    return {
        
        'AppId': json['AppId'],
    };
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSON(json: any): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames {
    return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsPlatformDataOptionsFacebookGames | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppId': value['AppId'],
    };
}

